import isNil from 'lodash/isNil';
import omitBy from 'lodash/omitBy';
import { parse, stringify } from 'query-string';
import type { Filters } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/state/ui/main/tabs/dependencies/filters/types.tsx';
import { createRouterSelector } from '@atlassian/react-resource-router';

const stringifyValues = (values: (string | number)[]) => values.join(',');
const parseValues = (value: string) => value.split(',');

const filterValues = (value: unknown) =>
	isNil(value) || (typeof value === 'number' && value === -1);

export const stringifyFilterQueryParams = (filters: Filters): string => {
	const filteredValues = omitBy(
		{
			rollupBy: filters.rollupBy,
			rollupHierarchyLevel: filters.rollupHierarchyLevel,
			issueInFocus: filters.issueInFocus,
			groupBy: filters.groupBy,
			issueFilter: filters.issueFilter,
			projectFilter: filters.projectFilter ? stringifyValues(filters.projectFilter) : null,
			sprintFilter: filters.sprintFilter ? stringifyValues(filters.sprintFilter) : null,
			issueLinkTypeFilter: filters.issueLinkTypeFilter
				? stringifyValues(filters.issueLinkTypeFilter)
				: null,
		},
		filterValues,
	);

	return stringify(filteredValues);
};

export const parseFilterQueryParams = (query: string): Filters => {
	const params = parse(query);

	return {
		rollupBy: params.rollupBy ? params.rollupBy : null,
		rollupHierarchyLevel: params.rollupHierarchyLevel ? Number(params.rollupHierarchyLevel) : -1,
		issueInFocus: params.issueInFocus ? params.issueInFocus : null,
		groupBy: params.groupBy ? params.groupBy : null,
		issueFilter: params.issueFilter ? params.issueFilter : null,
		projectFilter: params.projectFilter ? parseValues(params.projectFilter) : null,
		sprintFilter: params.sprintFilter ? parseValues(params.sprintFilter) : null,
		issueLinkTypeFilter: params.issueLinkTypeFilter
			? parseValues(params.issueLinkTypeFilter)
			: null,
	};
};

export const useLocation = createRouterSelector((state) => state.location);
